export default __webpack_public_path__ + "static/media/linkIcon.f9181695.svg";